'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reduxForm = require('redux-form');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _applicationFormValidation = require('./applicationFormValidation');

var _applicationFormValidation2 = _interopRequireDefault(_applicationFormValidation);

var _applicationForm = require('redux/modules/applicationForm');

var applicationFormActions = _interopRequireWildcard(_applicationForm);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApplicationForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isFormVisible: state.applicationForm.isFormVisible
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)(applicationFormActions, dispatch);
}), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'application-form',
  fields: ['type', 'variant', 'email', 'tel', 'firstName', 'lastName', 'pin', 'numberOfAdults', 'numberOfKids', 'street', 'city', 'zip', 'ownBike', 'winterEquipment', 'invoicingData', 'companyName', 'companyTin', 'companyVin', 'companyStreet', 'companyCity', 'companyZip', 'terms'],
  validate: _applicationFormValidation2.default
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ApplicationForm, _Component);

  function ApplicationForm() {
    (0, _classCallCheck3.default)(this, ApplicationForm);
    return (0, _possibleConstructorReturn3.default)(this, (ApplicationForm.__proto__ || (0, _getPrototypeOf2.default)(ApplicationForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ApplicationForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          type = _props$fields.type,
          variant = _props$fields.variant,
          email = _props$fields.email,
          tel = _props$fields.tel,
          firstName = _props$fields.firstName,
          lastName = _props$fields.lastName,
          pin = _props$fields.pin,
          numberOfAdults = _props$fields.numberOfAdults,
          numberOfKids = _props$fields.numberOfKids,
          street = _props$fields.street,
          city = _props$fields.city,
          zip = _props$fields.zip,
          ownBike = _props$fields.ownBike,
          winterEquipment = _props$fields.winterEquipment,
          invoicingData = _props$fields.invoicingData,
          companyName = _props$fields.companyName,
          companyTin = _props$fields.companyTin,
          companyVin = _props$fields.companyVin,
          companyStreet = _props$fields.companyStreet,
          companyCity = _props$fields.companyCity,
          companyZip = _props$fields.companyZip,
          terms = _props$fields.terms,
          handleSubmit = _props.handleSubmit,
          values = _props.values,
          preFilled = _props.preFilled,
          isFormVisible = _props.isFormVisible;


      email.messages = {
        required: 'Vyplňte, prosím, e-mail. Pošleme Vám na něj potvrzení o přihlášení.',
        email: 'Vyplňte, prosím, Váš e-mail ve formátu vas.email@poskytovatel.cz.'
      };
      tel.messages = {
        required: 'Vyplňte, prosím, Vaše telefonní číslo. Volat Vám budeme pouze pokud to bude nezbytně nutné.',
        phone: 'Vyplňte, prosím, Vaše telefonní číslo ve formátu +420 123 456 789.'
      };
      firstName.messages = {
        required: 'Vyplňte, prosím, křestní jméno Vašeho dítěte.',
        maxLength: 'Pokud je křestní jméno Vašeho dítěte delší než 50 znaků, napište nám e-mail na info@nenudimse.cz a my to vyřešíme :)'
      };
      lastName.messages = {
        required: 'Vyplňte, prosím, příjmení Vašeho dítěte.',
        maxLength: 'Pokud je příjmení Vašeho dítěte delší než 50 znaků, napište nám e-mail na info@nenudimse.cz a my to vyřešíme :)'
      };
      pin.messages = {
        required: 'Vyplňte, prosím, rok narození Vašeho dítěte.',
        pin: 'Vyplňte, prosím, rok narození Vašeho dítěte.',
        tip: ''
      };
      numberOfAdults.messages = {
        required: 'Vyplňte, prosím, kolik dospělých přihlašujete.',
        tip: ''
      };
      numberOfKids.messages = {
        required: 'Vyplňte, prosím, kolik dětí přihlašujete.',
        tip: ''
      };
      street.messages = {
        maxLength: 'Pokud je název ulice delší než 50 znaků, napište nám e-mail na info@nenudimse.cz a my to vyřešíme :)'
      };
      city.messages = {
        required: 'Vyplňte, prosím, město, ve kterém žijete.',
        maxLength: 'Pokud je název města delší než 50 znaků, napište nám e-mail na info@nenudimse.cz a my to vyřešíme :)'
      };
      zip.messages = {
        required: 'Vyplňte, prosím, PSČ ve formátu 123 45.',
        zip: 'Vyplňte, prosím, PSČ ve formátu 123 45.'
      };
      terms.messages = {
        isTrue: 'S podmínkami je nutné souhlasit.'
      };

      var styles = require('./ApplicationForm.scss');
      var renderInput = function renderInput(field, label) {
        var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { type: 'text' };
        return _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('form-group', field.error && field.touched ? 'has-error' : '', field.valid && field.touched ? 'valid' : '') },
          _react2.default.createElement(
            'label',
            { htmlFor: field.name, className: 'col-xs-12' },
            label
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement('input', (0, _extends3.default)({}, props, { className: 'form-control', id: field.name }, field)),
            !field.touched && typeof field.messages !== 'undefined' && _react2.default.createElement(
              'div',
              { className: 'form-control-tip' },
              field.messages.tip
            ),
            field.error && field.touched && _react2.default.createElement(
              'div',
              { className: 'form-control-tip text-danger' },
              field.messages[field.error.rule]
            )
          )
        );
      };
      var renderTermsInput = function renderTermsInput(field) {
        return _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('row', field.error && field.touched ? 'has-error' : '', field.valid && field.touched ? 'valid' : '') },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('col-xs-12 col-lg-8', styles.radioBtn) },
            _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox', className: 'hidden', id: field.name }, field)),
            _react2.default.createElement(
              'label',
              { htmlFor: field.name, className: (0, _classnames2.default)(styles.radioLabelInline) },
              _react2.default.createElement(
                'div',
                { className: styles.checkCircle },
                _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
              ),
              _react2.default.createElement(
                'strong',
                null,
                'Souhlas\xEDm se ',
                _react2.default.createElement(
                  'a',
                  { href: '/smluvni-podminky.pdf', target: '_blank', title: 'Smluvn\xED podm\xEDnky' },
                  'smluvn\xEDmi'
                ),
                ' a ',
                _react2.default.createElement(
                  'a',
                  { href: '/storno-podminky.pdf', target: '_blank', title: 'Storno podm\xEDnky' },
                  'storno podm\xEDnkami'
                )
              )
            ),
            field.error && field.touched && _react2.default.createElement(
              'div',
              { className: 'form-control-tip  text-danger' },
              field.messages[field.error.rule]
            )
          )
        );
      };
      var renderOwnBike = function renderOwnBike(field) {
        return _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(field.error && field.touched ? 'has-error' : '', field.valid && field.touched ? 'valid' : '') },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('col-xs-12 col-lg-8', styles.radioBtn) },
            _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox', className: 'hidden', id: field.name }, field)),
            _react2.default.createElement(
              'label',
              { htmlFor: field.name, className: (0, _classnames2.default)(styles.radioLabelInline) },
              _react2.default.createElement(
                'div',
                { className: styles.checkCircle },
                _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
              ),
              _react2.default.createElement(
                'strong',
                null,
                'Beru si kolo'
              )
            )
          )
        );
      };
      var renderWinterEquipment = function renderWinterEquipment(field) {
        return (
          /* <div className={classNames('form-group', (field.error && field.touched ? 'has-error' : ''), (field.valid && field.touched ? 'valid' : ''))}>
            <label htmlFor={field.name} className="col-xs-12">Na čem bude vaše dítě na táboře jezdit?</label>
            <div className="col-xs-12">
              <select id={field.name} className="form-control" {...field}>
                <option value="bike">Kolo</option>
                <option value="inline">In-line brusle</option>
              </select>
            </div>
          </div>;*/
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('form-group', field.error && field.touched ? 'has-error' : '', field.valid && field.touched ? 'valid' : '') },
            _react2.default.createElement(
              'label',
              { htmlFor: field.name, className: 'col-xs-12' },
              'Na \u010Dem bude va\u0161e d\xEDt\u011B na t\xE1bo\u0159e jezdit?'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'select',
                (0, _extends3.default)({ id: field.name, className: 'form-control' }, field),
                _react2.default.createElement(
                  'option',
                  { value: 'ski' },
                  'Ly\u017Ee'
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'snowboard' },
                  'Snowboard'
                )
              )
            )
          )
        );
      };
      var renderInvoicingDataInput = function renderInvoicingDataInput(field) {
        return _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('row', field.error && field.touched ? 'has-error' : '', field.valid && field.touched ? 'valid' : '') },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('col-xs-12 col-lg-8', styles.radioBtn) },
            _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox', className: 'hidden', id: field.name }, field)),
            _react2.default.createElement(
              'label',
              { htmlFor: field.name, className: (0, _classnames2.default)(styles.radioLabelInline) },
              _react2.default.createElement(
                'div',
                { className: styles.checkCircle },
                _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
              ),
              _react2.default.createElement(
                'strong',
                null,
                'Faktura\u010Dn\xED \xFAdaje jsou odli\u0161n\xE9 od m\xFDch kontaktn\xEDch'
              )
            )
          )
        );
      };

      var options = void 0;
      switch (values.type) {
        case 'suburban-camp':
          options = _react2.default.createElement(
            'h3',
            null,
            'Bohu\u017Eel nem\xE1me \u017E\xE1dn\xFD voln\xFD p\u0159\xEDm\u011Bstsk\xFD t\xE1bor.'
          );
          break;

        case 'training-group':
          options = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-3', styles.radioBtn, variant.dirty && variant.valid && variant.value !== 'training-group-omska-praha-10-2022' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'variant-training-group-omska-praha-10-2022' }, variant, { className: 'hidden', value: 'training-group-omska-praha-10-2022', checked: variant.value === 'training-group-omska-praha-10-2022' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'variant-training-group-omska-praha-10-2022', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  '\xDAter\xFD a \u010Dtvrtek'
                ),
                _react2.default.createElement(
                  'small',
                  null,
                  'Omsk\xE1, Praha 10'
                )
              )
            ),
            false && _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-3', styles.radioBtn, variant.dirty && variant.valid && variant.value !== 'training-group-jakutska-praha-10-2019' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'variant-training-group-jakutska-praha-10-2019' }, variant, { className: 'hidden', value: 'training-group-jakutska-praha-10-2019', checked: variant.value === 'training-group-jakutska-praha-10-2019' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'variant-training-group-jakutska-praha-10-2019', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  '\xDAter\xFD a \u010Dtvrtek'
                ),
                _react2.default.createElement(
                  'small',
                  null,
                  'Jakutsk\xE1, Praha 10'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-3', styles.radioBtn, variant.dirty && variant.valid && variant.value !== 'training-group-zs-bitovska-praha-4-2023' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'variant-training-group-zs-bitovska-praha-4-2023' }, variant, { className: 'hidden', value: 'training-group-zs-bitovska-praha-4-2023', checked: variant.value === 'training-group-zs-bitovska-praha-4-2023' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'variant-training-group-zs-bitovska-praha-4-2023', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  'St\u0159eda'
                ),
                _react2.default.createElement(
                  'small',
                  null,
                  'Z\u0160 B\xEDtovsk\xE1, Praha 4'
                )
              )
            )
          );
          break;

        default:
          /* options = (<h3>Bohužel nemáme žádný volný dětský tábor.</h3>); */
          options = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-3', styles.radioBtn, variant.dirty && variant.valid && variant.value !== 'camp-2026-07-04-11' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'variant-camp-2026-07-04-11' }, variant, { className: 'hidden', value: 'camp-2026-07-04-11', checked: variant.value === 'camp-2026-07-04-11' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'variant-camp-2026-07-04-11', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  '4.-11.7.',
                  _react2.default.createElement(
                    'small',
                    null,
                    '2026'
                  )
                ),
                _react2.default.createElement(
                  'small',
                  null,
                  'Sport Resort Nenud\xEDm se, S\xE1zava'
                )
              ),
              _react2.default.createElement(
                'a',
                { href: '/detske-tabory/4.-11.7.2026' },
                'V\xEDce informac\xED o term\xEDnu'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-3', styles.radioBtn, variant.dirty && variant.valid && variant.value !== 'camp-2026-08-01-08' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'variant-camp-2026-08-01-08' }, variant, { className: 'hidden', value: 'camp-2026-08-01-08', checked: variant.value === 'camp-2026-08-01-08' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'variant-camp-2026-08-01-08', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  '1.-8.8.',
                  _react2.default.createElement(
                    'small',
                    null,
                    '2026'
                  )
                ),
                _react2.default.createElement(
                  'small',
                  null,
                  'Sport Resort Nenud\xEDm se, S\xE1zava'
                )
              ),
              _react2.default.createElement(
                'a',
                { href: '/detske-tabory/1.-8.8.2026' },
                'V\xEDce informac\xED o term\xEDnu'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-3', styles.radioBtn, variant.dirty && variant.valid && variant.value !== 'camp-2026-08-08-15' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'variant-camp-2026-08-08-15' }, variant, { className: 'hidden', value: 'camp-2026-08-08-15', checked: variant.value === 'camp-2026-08-08-15' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'variant-camp-2026-08-08-15', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  '8.-15.8.',
                  _react2.default.createElement(
                    'small',
                    null,
                    '2026'
                  )
                ),
                _react2.default.createElement(
                  'small',
                  null,
                  'Sport Resort Nenud\xEDm se, S\xE1zava'
                )
              ),
              _react2.default.createElement(
                'a',
                { href: '/detske-tabory/8.-15.8.2026' },
                'V\xEDce informac\xED o term\xEDnu'
              )
            )
          );
          break;
      }

      if (!isFormVisible) {
        _reactGa2.default.event({
          category: 'Přihláška',
          action: 'Odeslána'
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        isFormVisible && _react2.default.createElement(
          'form',
          { className: 'form-horizontal', onSubmit: handleSubmit },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('form-group', type.error && type.touched ? 'has-error' : '', type.valid && type.touched ? 'valid' : '', typeof preFilled !== 'undefined' && typeof preFilled.type !== 'undefined' ? 'hidden' : '') },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'label',
                null,
                'Vyberte, kam chcete sv\xE9 d\xEDt\u011B p\u0159ihl\xE1sit'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-4 col-lg-3', styles.radioBtn, type.dirty && type.valid && type.value !== 'camp' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'type-camp' }, type, { className: 'hidden', value: 'camp', checked: type.value === 'camp' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'type-camp', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  'D\u011Btsk\xFD t\xE1bor'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/detske-tabory', eventKey: 0, target: '_blank' },
                'V\xEDce informac\xED o d\u011Btsk\xFDch t\xE1borech'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-4 col-lg-3', styles.radioBtn, type.dirty && type.valid && type.value !== 'training-group' ? styles.disabledRadioBtn : '') },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'type-training-group' }, type, { className: 'hidden', value: 'training-group', checked: type.value === 'training-group' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'type-training-group', className: styles.radioLabel },
                _react2.default.createElement(
                  'div',
                  { className: styles.checkCircle },
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.circle, 'fa fa-circle-thin'), 'aria-hidden': 'true' }),
                  _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.check, 'fa fa-check-circle'), 'aria-hidden': 'true' })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  'Sportovn\xED p\u0159\xEDpravka'
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/sportovni-pripravka', eventKey: 2, target: '_blank' },
                'V\xEDce informac\xED o sportovn\xED p\u0159\xEDpravce'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('form-group', variant.error && variant.touched ? 'has-error' : '', variant.valid && variant.touched ? 'valid' : '', type.dirty && type.valid || variant.dirty || typeof preFilled !== 'undefined' && typeof preFilled.type !== 'undefined' && typeof type.value !== 'undefined' ? '' : 'inactive', typeof preFilled !== 'undefined' && typeof preFilled.variant !== 'undefined' ? 'hidden' : '') },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'label',
                null,
                'Vyberte term\xEDn, o kter\xFD m\xE1te z\xE1jem'
              )
            ),
            options
          ),
          _react2.default.createElement(
            'fieldset',
            { className: (0, _classnames2.default)('form-group', variant.dirty && variant.valid || typeof preFilled !== 'undefined' && typeof preFilled.variant !== 'undefined' && typeof variant.value !== 'undefined' || firstName.dirty || lastName.dirty || pin.dirty ? '' : 'inactive') },
            variant.value !== 'camp-2023-05-05-08' && _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'legend',
                null,
                'P\u0159ihla\u0161ovan\xE9 d\xEDt\u011B'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'controls' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6 col-lg-4' },
                renderInput(firstName, variant.value !== 'camp-2023-05-05-08' ? 'Křestní jméno dítěte' : 'Křestní jméno')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6 col-lg-4' },
                renderInput(lastName, 'Přijmení')
              ),
              variant.value !== 'camp-2023-05-05-08' && _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4 col-lg-2' },
                    renderInput(pin, 'Rok narození', { pattern: '[0-9]{4}' })
                  )
                )
              ),
              variant.value === 'camp-2023-05-05-08' && _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-lg-2' },
                    renderInput(numberOfAdults, 'Počet dospělých', { pattern: '[0-9]{4}' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-lg-2' },
                    renderInput(numberOfKids, 'Počet dětí', { pattern: '[0-9]{4}' })
                  )
                )
              ),
              variant.value === 'camp-2017-10-25-29' && _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderOwnBike(ownBike)
              ),
              (variant.value === 'camp-2020-02-22-29' || variant.value === 'camp-2020-02-15-22') && _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderWinterEquipment(winterEquipment)
              ),
              (variant.value === 'camp-2020-10-27-11-01' || variant.value === 'camp-2021-02-27-03-06' || variant.value === 'camp-2021-02-20-27') && _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderWinterEquipment(winterEquipment)
              )
            )
          ),
          _react2.default.createElement(
            'fieldset',
            { className: (0, _classnames2.default)('form-group', firstName.dirty && firstName.valid && lastName.dirty && lastName.valid && (variant.value === 'camp-2023-05-05-08' || pin.dirty && pin.valid) || email.dirty || tel.dirty || street.dirty || city.dirty || terms.dirty ? '' : 'inactive') },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'legend',
                null,
                'Kontaktn\xED \xFAdaje'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'controls' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(email, 'Váš e-mail', { type: 'email' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(tel, 'Telefonní číslo', { type: 'tel' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(street, 'Ulice, č.p.')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(city, 'Město')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(zip, 'PSČ', { type: 'number', min: 10000, max: 99999, step: 1 })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('form-group no-margin', email.dirty && email.valid && tel.dirty && tel.valid && street.dirty && street.valid && city.dirty && city.valid || email.dirty || tel.dirty || street.dirty || city.dirty || terms.dirty ? '' : 'inactive') },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              renderInvoicingDataInput(invoicingData)
            )
          ),
          _react2.default.createElement(
            'fieldset',
            { className: (0, _classnames2.default)('form-group', invoicingData.value ? '' : 'hidden') },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'legend',
                null,
                'Faktura\u010Dn\xED \xFAdaje'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'controls' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(companyName, 'Název firmy')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(companyTin, 'IČO', { type: 'tel' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(companyVin, 'DIČ', { type: 'tel' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(companyStreet, 'Ulice, č.p.')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(companyCity, 'Město')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-lg-8' },
                renderInput(companyZip, 'PSČ', { type: 'number', min: 10000, max: 99999, step: 1 })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('form-group', email.dirty && email.valid && tel.dirty && tel.valid && street.dirty && street.valid && city.dirty && city.valid || email.dirty || tel.dirty || street.dirty || city.dirty || terms.dirty ? '' : 'inactive') },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              renderTermsInput(terms)
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-success btn-lg', onClick: handleSubmit },
                _react2.default.createElement('i', { className: 'fa fa-paper-plane' }),
                ' Odeslat p\u0159ihl\xE1\u0161ku'
              )
            )
          )
        ),
        !isFormVisible && _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'h2',
              null,
              'D\u011Bkujeme za va\u0161i p\u0159ihl\xE1\u0161ku.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'p',
              null,
              'P\u0159ihl\xE1\u0161ka byla \xFAsp\u011B\u0161n\u011B ulo\u017Eena a potvrzen\xED v\xE1m p\u0159islo na e-mail.'
            )
          )
        )
      );
    }
  }]);
  return ApplicationForm;
}(_react.Component), _class2.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  values: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  preFilled: _react.PropTypes.object,
  isFormVisible: _react.PropTypes.bool
}, _temp)) || _class) || _class);
exports.default = ApplicationForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ApplicationForm/ApplicationForm.js
// module id = 1097
// module chunks = 0